import styled from "styled-components";

export const ConsolePageModalFooterContainer = styled.div`
  padding: 12px 24px;

  border-top: 1px solid #373940;

  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
`;
